export const OTHER_MARKET_SLUG = 'other';

export const DEFAULT_MARKETS = [
  { slug: 'new-york', name: 'New York', country: 'United States', status: 'prelaunch', order: 1 },
  { slug: 'los-angeles', name: 'Los Angeles', country: 'United States', status: 'prelaunch', order: 2 },
  { slug: 'miami', name: 'Miami', country: 'United States', status: 'prelaunch', order: 3 },
  { slug: 'chicago', name: 'Chicago', country: 'United States', status: 'prelaunch', order: 4 },
  { slug: 'boston', name: 'Boston', country: 'United States', status: 'prelaunch', order: 5 },
  { slug: 'washington-dc', name: 'Washington DC', country: 'United States', status: 'prelaunch', order: 6 },
  { slug: 'san-francisco', name: 'San Francisco', country: 'United States', status: 'prelaunch', order: 7 },
  { slug: 'toronto', name: 'Toronto', country: 'Canada', status: 'prelaunch', order: 8 },
  { slug: 'london', name: 'London', country: 'United Kingdom', status: 'prelaunch', order: 9 },
  { slug: 'tel-aviv', name: 'Tel Aviv', country: 'Israel', status: 'prelaunch', order: 10 },
  { slug: 'jerusalem', name: 'Jerusalem', country: 'Israel', status: 'prelaunch', order: 11 },
];

export function normalizeCity(value = '') {
  return String(value)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function findMarket(markets, cityOrSlug) {
  const normalized = normalizeCity(cityOrSlug);
  if (!normalized) return null;

  const aliases = {
    dc: 'washington-dc',
    washington: 'washington-dc',
    'washington-d-c': 'washington-dc',
    sf: 'san-francisco',
    'nyc': 'new-york',
  };
  const slug = aliases[normalized] || normalized;

  return markets.find(
    (market) => market.slug === slug || normalizeCity(market.name) === slug
  ) || null;
}
